import React from 'react';
import './Phonetics.css';

export default function Phonetics(props) {
  return (
    <div className="Phonetics">
      <strong>Pronunciacion:&nbsp;</strong>

      {props.phonetics.map(function (phonetics, index) {
        if (phonetics.audio) {
          return (
            <span key={index}>
              <a
                href={phonetics.audio}
                target="_blank"
                rel="noreferrer noopener"
              >
                {phonetics.text}
              </a>
            </span>
          );
        } else return <span>{phonetics.text}&nbsp;</span>;
      })}
    </div>
  );
}
